import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'onboarding_state';

const initialState = {
	profileCreated: false,
	selectedPlanId: null,
	selectedPlanType: null,
	selectedBilling: null,
	checkoutStatus: null,
	userType: null,
	currentStep: 0,
	recommendedVideoIds: []
};

const OnboardingContext = createContext(null);

export const OnboardingProvider = ({ children }) => {
	const [state, setState] = useState(() => {
		const saved = sessionStorage.getItem(STORAGE_KEY);
		return saved ? JSON.parse(saved) : initialState;
	});

	useEffect(() => {
		sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
	}, [state]);

	const updateState = useCallback((updates) => {
		setState(prev => {
			const newState = { ...prev, ...updates };
			sessionStorage.setItem(STORAGE_KEY, JSON.stringify(newState));
			return newState;
		});
	}, []);

	const clearState = useCallback(() => {
		sessionStorage.removeItem(STORAGE_KEY);
		setState(initialState);
	}, []);

	return (
		<OnboardingContext.Provider value={{ state, updateState, clearState }}>
			{children}
		</OnboardingContext.Provider>
	);
};

export const useOnboardingState = () => {
	const context = useContext(OnboardingContext);
	if (!context) {
		throw new Error('useOnboardingState must be used within OnboardingProvider');
	}
	return context;
};
